import { DomainInitPayload } from '@sxm-de/dev-kits/web-sdk/types';
import {
    getAuthState,
    logErrorFromClientSdk,
} from '@sxm-de/dev-kits/web-sdk/utils';
import { createIdentity } from '../helpers/create-identity';

interface CreateIdentityIfEmailEligibleFnPayload {
    emailAddress: string;
    password?: string;
    locale: string;
}

export type CreateIdentityIfEmailEligibleFn = (
    payload: CreateIdentityIfEmailEligibleFnPayload,
) => Promise<void>;

export function initCreateIdentityIfEmailEligibleFn({
    dependencies,
}: DomainInitPayload): CreateIdentityIfEmailEligibleFn {
    const { clientSdk, microservicesSdk, appEventSdk } = dependencies;
    return async ({
        emailAddress,
        password,
        locale,
    }: CreateIdentityIfEmailEligibleFnPayload) => {
        let smsEligible: boolean;
        try {
            const response =
                await microservicesSdk.domains.identity.getAccountByEmail({
                    email: emailAddress,
                });
            // email not eligible if response contains at least 1 item in sms active subscription array
            smsEligible = !response.length;
        } catch (error: any) {
            logErrorFromClientSdk(error, dependencies);
            throw new Error('SYSTEM');
        }

        if (!smsEligible) {
            throw new Error('IDENTITY_NOT_ELIGIBLE_ERROR');
        }

        if (getAuthState() === 'authenticated') {
            await clientSdk.user.anonymousLogin(true);
        }

        await createIdentity(
            {
                emailAddress,
                ...(password ? { password } : {}),
                language: locale,
            },
            dependencies,
        );
        appEventSdk.trackEvent({
            event: 'customer-info',
            data: {
                customerType: 'NEW_SXIR_ACCOUNT',
            },
        });
    };
}
